import { useState } from "react";
import { useNavigate } from "react-router-dom";

const GATEWAY = import.meta.env.VITE_GATEWAY_URL ?? "http://localhost:8080";

export function ConnectPage() {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const cleaned = code.replace(/\D/g, "");
      const res = await fetch(`${GATEWAY}/v1/connect/redeem`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ code: cleaned })
      });
      if (!res.ok) {
        const j = await res.json().catch(() => ({}));
        setError(j.error ?? `gateway returned ${res.status}`);
        return;
      }
      const data = (await res.json()) as { sessionId: string; viewerTicket: string };
      navigate(`/viewer/${data.sessionId}?ticket=${encodeURIComponent(data.viewerTicket)}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  const cleaned = code.replace(/\D/g, "");
  const formatted = cleaned.replace(/(\d{3})(?=\d)/g, "$1 ");

  return (
    <section className="glass p-8 max-w-md mx-auto mt-12">
      <h1 className="text-2xl font-semibold mb-2">Connect to a remote device</h1>
      <p className="text-white/60 text-sm mb-6">
        Enter the 9-digit pairing code shown in the SPIDER® Viewer Agent.
      </p>
      <form onSubmit={submit} className="flex flex-col gap-4">
        <input
          autoFocus
          inputMode="numeric"
          value={formatted}
          onChange={(e) => setCode(e.target.value)}
          placeholder="000 000 000"
          maxLength={11}
          className="px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-3xl text-center tracking-widest font-mono outline-none focus:border-accent"
        />
        {error && <p className="text-red-400 text-sm">{error}</p>}
        <button
          type="submit"
          disabled={busy || cleaned.length < 8}
          className="btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {busy ? "Connecting…" : "Connect"}
        </button>
      </form>
    </section>
  );
}
